import { render, staticRenderFns } from "./EsqueciMinhaSenha.vue?vue&type=template&id=79d52527"
import script from "./EsqueciMinhaSenha.vue?vue&type=script&lang=js"
export * from "./EsqueciMinhaSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports